/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryExclametionMark: {
  name: 'battery-exclametion-mark';
  data: string;
} = {
  name: 'battery-exclametion-mark',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3.5A1.5 1.5 0 0 0 .5 5v6A1.5 1.5 0 0 0 2 12.5h10a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 12 3.5H2ZM1.5 5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V5Zm14 1a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6ZM7 5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 7 5Zm0 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
